import { render, staticRenderFns } from "./ProductFormVariantWeight.vue?vue&type=template&id=e440bc04&"
import script from "./ProductFormVariantWeight.vue?vue&type=script&lang=js&"
export * from "./ProductFormVariantWeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports